import { mdiMap } from '@mdi/js'

export default {
  title: 'District',
  to: 'district-list',
  icon: mdiMap,
  resource: 'DistrictAdmin',
  action: 'read',
}
